import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterModule } from "@angular/router";
import { EventInfoResponseBody } from "../../../services/types/events-management-response.type";
import { EventImageComponent } from "../event-image/event-image.component";

@Component({
  selector: "app-event-table-row",
  imports: [
    CommonModule,
    EventImageComponent,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    RouterModule,
  ],
  templateUrl: "./event-table-row.component.html",
  styleUrl: "./event-table-row.component.scss",
})
export class EventTableRowComponent {
  @Input({ required: true }) event!: EventInfoResponseBody;

  @Output() detailEventClick = new EventEmitter<number | string>();
}
